module.exports = __webpack_public_path__ + "static/media/hw_re_42.17780615.flv";